import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { TradingDataFilter } from "../../../data/clearing/tradingData/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const TradingDataFilterChipsComponent: React.FunctionComponent<TradingDataFilterChipsProps> = ({
  filter,
  removeFilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);
  
  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("dateto")}
          />
        </Grid>
      )}
      {filter.product && (
        <Grid item>
          <Chip
            label={filter.product.prodName}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("product")}
          />
        </Grid>
      )}
    </Grid>
  );
};

interface TradingDataFilterChipsProps {
  filter: TradingDataFilter;
  removeFilter: (type: keyof TradingDataFilter) => void;
}
